import config from "config/config";
import { viewMoreSlide } from "./viewMoreSlide";
import { noMessagesSlide } from "./noMessagesSlide";

export const constructFinalAlertsArray = (
  companyWideAlerts,
  userPolicyRelatedAlerts
) => {
  if (companyWideAlerts?.length > 0 && userPolicyRelatedAlerts?.length > 0) {
    return [
      ...companyWideAlerts.slice(0, parseInt(config.ALERTS_COUNT)),
      ...userPolicyRelatedAlerts.slice(0, parseInt(config.ALERTS_COUNT)),
      viewMoreSlide,
    ];
  } else if (companyWideAlerts?.length > 0) {
    return [
      ...companyWideAlerts.slice(0, parseInt(config.ALERTS_COUNT)),
      viewMoreSlide,
    ];
  } else if (userPolicyRelatedAlerts?.length > 0) {
    return [
      ...userPolicyRelatedAlerts.slice(0, parseInt(config.ALERTS_COUNT)),
      viewMoreSlide,
    ];
  } else {
    return [noMessagesSlide, viewMoreSlide];
  }
};
